import React from 'react';
export function DesktopIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 2H5a3 3 0 00-3 3v10a3 3 0 003 3h6v2H6a1 1 0 000 2h12a1 1 0 000-2h-5v-2h6a3 3 0 003-3V5a3 3 0 00-3-3zm1 13a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h14a1 1 0 011 1v10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5H7a2 2 0 00-2 2v1a1 1 0 002 0V7h1a1 1 0 000-2z"
  }));
}